import React from 'react';
import styles from './home.module.css';
import SearchContainer from '../SearchContainer';
import WhichBinLogo from '../../assets/whicbin.svg';
export var HomeContainer = function () {
    return (React.createElement("div", { className: styles.homeContainer },
        React.createElement("div", { className: styles.title },
            React.createElement(WhichBinLogo, null),
            React.createElement("h1", null, "Which Bin?")),
        React.createElement("p", null, "Find where you should throw your trash"),
        React.createElement("div", { className: styles.homeSearchContainer },
            React.createElement(SearchContainer, null))));
};
